import { notifications } from '@mantine/notifications';
import {
  getCashAccountKey,
  getCashAccountsKey,
  useGetCashAccount,
  useUpdateCashAccount,
} from 'api-hooks/cash-account';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import CashAccountForm from './components/form';

export type CashAccountViewParams = {
  id: string;
};

export default function CashAccountView(
  props: NavigationProps<NavigationRoutes.CashAccountsView>,
) {
  const { query } = useRouter();
  const id = query.id as string;
  const queryView = useGetCashAccount({ id }, { enabled: !!id });
  const updateMutation = useUpdateCashAccount();

  return (
    <CashAccountForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          cashAccountId: id,
          body: input,
        });

        queryClient.refetchQueries(getCashAccountsKey());
        queryClient.refetchQueries(getCashAccountKey({ id }));

        notifications.show({ message: result.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
